/*
 * @providesModule ForgotPasswordForm
 */

import React from 'react';
import {Text, TouchableOpacity, View} from 'react-native';
import styles from 'ForgotPasswordStyle';
import SkillzSVG from 'SkillzSVG';
import TextInputComponent from 'TextInputComponent';
import {_m} from 'INTL';

export interface ForgotPasswordFormProps {
  email: string;
  onChangeText: (text: string) => void;
  onSubmitPress: () => void;
  onCancelPress: () => void;
  inputUserNameFocus: boolean;
  setUserNameFocus: (focus: boolean) => void;
  inputError: boolean;
  viewHeight: number;
}

const TEST_IDS = {
  modalTestID: 'forgot_password_modal',
  titleTestID: 'forgot_password_title',
  messageTestID: 'forgot_password_message',
  inputTestID: 'forgot_password_username_input',
  submitTestID: 'forgot_password_submit',
  cancelTestID: 'forgot_password_cancel',
};

const ForgotPasswordForm = (props: ForgotPasswordFormProps) => {
  const usernameInput = () => {
    return (
      <View
        style={
          props.inputError
            ? styles.inputError
            : props.inputUserNameFocus
              ? styles.inputHighlight
              : styles.inputView
        }
        testID={TEST_IDS.inputTestID}
      >
        <TextInputComponent
          label={_m('Username or email')}
          value={props.email}
          showIcon={false}
          onChangeText={(value) => props.onChangeText(value)}
          style={styles.textInput}
          inputStyle={styles.textInInput}
          onFocus={() => props.setUserNameFocus(true)}
          onBlur={() => props.setUserNameFocus(false)}
          placeholderStyle={styles.placeHolderText}
          labelStyle={
            props.inputError
              ? styles.labelTextError
              : props.inputUserNameFocus
                ? styles.labelTextHighlight
                : styles.labelText
          }
          testID={TEST_IDS.inputTestID}
          accessibilityLabel={TEST_IDS.inputTestID}
          autoCorrect={false}
        />
      </View>
    );
  };

  const errorMessage = () => {
    if (props.inputError) {
      return (
        <View style={styles.errorContainer}>
          <SkillzSVG style={styles.errorIcon} source={'info_error.svg'} />
          <Text style={styles.errorMessage}>User does not exist</Text>
        </View>
      );
    }
    return null;
  };

  const submitButton = () => {
    return (
      <TouchableOpacity
        testID={TEST_IDS.submitTestID}
        onPress={() => props.onSubmitPress()}
        style={styles.submitButton}
      >
        <Text style={styles.loginText}>{_m('Submit')}</Text>
      </TouchableOpacity>
    );
  };

  const cancelButton = () => {
    return (
      <TouchableOpacity
        style={styles.cancelButton}
        testID={TEST_IDS.cancelTestID}
        onPress={() => props.onCancelPress()}
      >
        <Text style={styles.cancelText}>{_m('Cancel')}</Text>
      </TouchableOpacity>
    );
  };

  return (
    <View style={[styles.container, {height: props.viewHeight}]} testID={TEST_IDS.modalTestID}>
      <Text style={styles.headerText} testID={TEST_IDS.titleTestID}>
        {_m('Forgot your password?')}
      </Text>
      <Text style={styles.messageText} numberOfLines={2} testID={TEST_IDS.messageTestID}>
        {_m('Enter in your information below and we will email you a password reset link.')}
      </Text>
      {usernameInput()}
      {errorMessage()}
      {submitButton()}
      {cancelButton()}
    </View>
  );
};

export default ForgotPasswordForm;
